module.exports = __webpack_public_path__ + "static/img_1.fdb9a724.jpg";